export default "__VITE_ASSET__d8af1cfe__"